import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  CircularProgress,
  Skeleton
} from '@mui/material';
import moment from 'moment';
import 'moment/locale/pt-br';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import UploadBox from '../UploadBox/UploadBox';
import './ModalEnviarDocumentos.scss';
import ModalConfirmacaoUpload from '../ModalConfirmacaoUpload/ModalConfirmacaoUpload';
import useModalEnviarDocumentosHook from '../../hooks/useModalEnviarDocumentosHook';

export default function ModalEnviarDocumentos({
  open,
  onClose,
  dadosDetalhes,
  buscaDadosAtualizadosTela
}) {
  const {
    liberarBtnEnviarDocumentos,
    handleUploadedFilesChange,
    enviarDocumentosTitulos,
    excluirArquivoEnviado,
    loadingTituloPendente,
    loadingProsseguir,
    arquivosEnviados,
    titulosPendentes,
    setObservacoes,
    setModalAlerta,
    onUploadFiles,
    observacoes,
    modalAlerta,
    handleClose
  } = useModalEnviarDocumentosHook({ open, onClose, dadosDetalhes, buscaDadosAtualizadosTela });

  return (
    <Box>
      <Dialog
        className="modal-envio-documentos"
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle className="modal-title">Enviar documentos</DialogTitle>

        <DialogContent className="modal-content">
          <Typography className="modal-description">
            Para que a análise continue, informe os arquivos pendentes ou observações referente aos
            títulos para que seja dado sequência.
          </Typography>

          <Grid container className="grid-box-documentos">
            {loadingTituloPendente && (
              <Grid item xs={12} md={9}>
                <Box>
                  <Box>
                    <Skeleton
                      className="skeleton-custom"
                      variant="rectangular"
                      animation="wave"
                      width="80%"
                      height={25}
                    />
                  </Box>

                  <Grid container>
                    <Grid item xs={12} md={9}>
                      <Skeleton
                        className="skeleton-custom mt-3"
                        variant="rectangular"
                        animation="wave"
                        height={180}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            )}

            {!loadingTituloPendente && (
              <>
                {titulosPendentes.map((titulo, index) => (
                  <Grid item xs={12} md={9} key={index}>
                    <Box className="titulo-header">
                      <Typography>
                        Envio da correção do Borderô <strong>{titulo.NBORDERO}</strong> de valor de:
                        <strong> R$ </strong>
                        <strong>
                          {parseFloat(titulo.VALOR).toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </strong>
                        <span> e vencimento em: </span>
                        <strong>{moment(titulo.VENCIMENTO).format('DD/MM/yyyy')}</strong>
                      </Typography>
                    </Box>

                    <Grid item xs={12} md={9}>
                      <UploadBox
                        onFilesChange={(files, onProgress) =>
                          onUploadFiles(files, onProgress, titulo.UUID)
                        }
                        arquivosEnviados={arquivosEnviados}
                        // onRemoveServerFile={excluirArquivoEnviado}
                        onRemoveServerFile={server => excluirArquivoEnviado(server, titulo.UUID)}
                        onUploadedFilesChange={handleUploadedFilesChange}
                      />
                    </Grid>
                  </Grid>
                ))}

                <Grid item xs={12} md={9}>
                  <Grid className="sub-item-upload" item xs={12} md={9}>
                    <TextField
                      variant="outlined"
                      label="Observações da atualização"
                      className="observacoes-textfield"
                      fullWidth
                      multiline
                      rows={2}
                      value={observacoes}
                      onChange={e => setObservacoes(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={12} className="button-row">
              <Box className="box-btn-upload">
                <Button className="btn-cancelar" onClick={onClose} disabled={loadingProsseguir}>
                  Cancelar
                </Button>
                <Button
                  className="btn-processeguir-upload"
                  onClick={() => enviarDocumentosTitulos()}
                  disabled={loadingProsseguir || loadingTituloPendente || !liberarBtnEnviarDocumentos}
                >
                  <Box className="box-icone">
                    {!loadingProsseguir && (
                      <>
                        Enviar documentação &nbsp;
                        <SyncAltIcon />
                      </>
                    )}
                    {loadingProsseguir && (
                      <>
                        Enviando a documentação &nbsp;
                        <CircularProgress size={20} color="inherit" />
                      </>
                    )}
                  </Box>
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <ModalConfirmacaoUpload open={modalAlerta} onClose={() => setModalAlerta(false)} />
    </Box>
  );
}
